<script setup lang="ts">
import { storeToRefs } from "pinia"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog"
import { Separator } from "@/components/ui/separator"
import { Button } from "@/components/ui/button"
import GlowIcon from "@/components/af/GlowIcon/GlowIcon.vue"
import { usePreviousStateModalStore } from "./previousStateModal.store"
import { useI18nStore } from "@/stores/i18n"

const { currentLocale } = storeToRefs(useI18nStore())
const { isActive } = storeToRefs(usePreviousStateModalStore())

function onLeave() {
  window.location.href = "/"
}
</script>

<template>
  <Dialog v-model:open="isActive">
    <DialogContent
      :class="
        [
          'border-afbranding-border z-60 bg-white',
          currentLocale.iso_code_639 === 'ar-SA' && 'arabic',
        ].join(' ')
      "
    >
      <GlowIcon class="mx-auto" icon="fa-thin fa-calendar-clock" />

      <div class="mx-auto w-48">
        <Separator class="bg-grey-lighten-3" />
      </div>

      <div class="flex flex-col gap-6">
        <DialogTitle class="text-afbranding-heading text-center">
          {{ $t("general.quit.assessment.title") }}
        </DialogTitle>

        <DialogDescription class="text-afbranding-text text-center">
          {{ $t("general.quit.assessment.body") }}
        </DialogDescription>
      </div>

      <div
        class="-mx-5 flex flex-col items-center justify-center gap-4 px-5 lg:m-0 lg:flex-row lg:px-0"
      >
        <Separator class="bg-grey-lighten-3 lg:hidden" />
        <div class="flex w-full flex-col-reverse gap-4 md:w-auto md:flex-row">
          <Button variant="secondary" class="w-full" @click="isActive = false">
            {{ $t("general.cancel") }}
          </Button>
          <Button @click="onLeave">{{ $t("general.back") }}</Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>
